import { useFormContext, Controller } from 'react-hook-form'
import { SpokeFeedbackData } from '.'
import styles from './styles.module.scss'
import { InputField } from '@components/ui/formElements/form/InputField'
import { TextareaField } from '@components/ui/formElements/form/Textarea'
import Bullet from '@components/ui/formElements/Bullet'
import { FormContentProps } from './types'

type FeedbackFieldProps = {
  field: FormContentProps['data']
  getBulletLabels: (id: string) => { leftLabel: string; rightLabel: string }
}

export default function FeedbackField({
  field,
  getBulletLabels
}: FeedbackFieldProps) {
  const { control } = useFormContext<SpokeFeedbackData>()

  if (field.type === 'bullet') {
    const { leftLabel, rightLabel } = getBulletLabels(field.id)

    return (
      <div className={styles.FormField}>
        <p className={styles.FormLabel}>{field.question}</p>

        <Controller
          name={field.id as keyof SpokeFeedbackData}
          control={control}
          defaultValue=""
          render={({ field: rhfField }) => (
            <div className={styles.FormRadios__inline}>
              {field.answers.map(answer => (
                <Bullet
                  key={answer}
                  id={field.id}
                  label={answer}
                  value={answer}
                  isSelected={rhfField.value === answer}
                  onChange={val => rhfField.onChange(val)}
                />
              ))}
            </div>
          )}
        />

        <div className={styles.FormDetails}>
          <p className={styles.FormDetails__one}>{leftLabel}</p>
          <p className={styles.FormDetails__two}>1 - 10</p>
          <p className={styles.FormDetails__three}>{rightLabel}</p>
        </div>
      </div>
    )
  }

  if (field.type === 'textarea') {
    return (
      <div className={styles.FormField}>
        <TextareaField
          id={field.id}
          name={field.question}
          required={field.required}
          placeholder={field.placeholder}
          showDefaultLabel={true}
        />
      </div>
    )
  }

  if (field.type === 'email' || field.type === 'text') {
    return (
      <div className={styles.FormField}>
        <InputField
          name={field.id}
          label={field.question}
          id={field.id}
          required={field.required}
          placeholder={field.placeholder}
        />
      </div>
    )
  }

  return null
}
